import {
    locationFormDefaultValues,
    personFormDefaultValues,
    vehicleFormDefaultValues,
} from '../../search-windows/configuration';
import { BoloSearchFormType } from './types';
import { DUMMY_VALUE_TO_CLEAR_RADIO_GROUP } from '../../search-windows/constants';

export const boloSearchFormDefaultValues: BoloSearchFormType = {
    activeDateRange: null,
    activeDateTimeRangeOption: null,
    boloNumbers: [{ number: '' }],
    boloTypes: [],
    createdByUsers: [],
    descriptionKeywords: '',
    dispatchAreas: [],
    expirationDateRange: null,
    expirationDateTimeRangeOption: null,
    fuzzyMatchingEnabled: true,
    includeActive: true,
    labels: [],
    locations: [locationFormDefaultValues],
    locationVerification: DUMMY_VALUE_TO_CLEAR_RADIO_GROUP,
    persons: [personFormDefaultValues],
    polygonPoints: [
        { latitude: '', longitude: '' },
        { latitude: '', longitude: '' },
        { latitude: '', longitude: '' },
    ],
    priorities: [],
    subdivisions: [],
    vehicles: [{ ...vehicleFormDefaultValues, towType: null }],
};
